import Data from './Data';

const AnchorBlockSidebar = (props: any) => {
  return <Data {...props} />;
};

export default AnchorBlockSidebar;
